<template>
  <b-button :variant="variant"
            :disabled="disabled"
            @click="click">
            <slot></slot>
            <span v-if="showSpinner" class="spinner" :style="style"></span>
  </b-button>
</template>

<script>

export default {
  name: 'bButtonWithSpinner',
  props: {
    click: {
      type: Function,
      required: true
    },
    variant: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showSpinner: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style () {
      return {
        borderTopColor: '#3498db',
        width: '18px',
        height: '18px',
        borderWidth: '4px',
        animationDuration: '1s'
      }
    }
  }
}
</script>

<style scoped>
  .spinner {
    opacity: 1;
    display: inline-block;
    vertical-align: middle;
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 1s linear infinite;
    margin: 0 0 0 10px;
    padding: 0;
    transition: all 0.2s ease;
  }
  .hidden > .spinner {
    max-width: 0 !important;
    max-height: 0 !important;
    border-width: 0 !important;
    margin: 0;
    opacity: 0;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
